module.exports = __webpack_public_path__ + "img/icon_videos_button.5228b03f.svg";